import React, { Component } from 'react';
import { Panel } from 'react-bootstrap';
import { Field } from 'redux-form';
import { Input, Radio } from '../../../common/components/formControls';
import withResourcesNamespace from '../../../common/components/withResourcesNamespace';

const yesNoOptions = (t) => {
	return [
		{ value: 'true', label: t('Yes') },
		{ value: 'false', label: t('No') }
	];
};

const parseBoolean = value => value === 'true' ? true : false;

class MedicalInformationForm extends Component {

	componentWillReceiveProps(nextProps) {
		if (this.props.currentFormValues) {
			const calculatedFields = this.getCalculatedFields(nextProps.currentFormValues);
			Object.keys(calculatedFields).forEach(field => {
				const nextValue = calculatedFields[field];
				if (this.props.currentFormValues[field] !== nextValue) {
					this.props.changeFormValue(field, nextValue);
				}
			});
		}
	}

	getCalculatedFields(formValues) {
		const hasAnyMedicalInformation = formValues['doesHaveAllergiesOrSensitivities'] ||
			formValues['hasDiagnosedAtRiskOfAnaphylaxsis'] || formValues['doesHaveAutoInjectionDevice'] ||
			formValues['doesHaveOtherMedicalConditions'] || formValues['doesHaveOtherInformation'];

		const medicalConditions = [];
		if (formValues['doesHaveAllergiesOrSensitivities']) {
			medicalConditions.push(formValues['allergiesOrSensitivities']);
		}
		if (formValues['hasDiagnosedAtRiskOfAnaphylaxsis']) {
			medicalConditions.push('Anaphylaxsis risk');
		}
		if (formValues['doesHaveAutoInjectionDevice']) {
			medicalConditions.push('Has auto-injection device');
		}
		if (formValues['doesHaveOtherMedicalConditions']) {
			medicalConditions.push(formValues['otherMedicalConditions']);
		}
		if (formValues['doesHaveOtherInformation']) {
			medicalConditions.push(formValues['otherInformation']);
		}

		return { hasAnyMedicalInformation, medicalConditionsJson: JSON.stringify(medicalConditions) };
	}

	render() {
		const { t, isReadOnly } = this.props;
		const colSize = { labelCol: 4, valueCol: 8 };

		return <div>
			<Panel>
				<Panel.Body>
					<Panel className='medical-information-sub-panel'>
						<Panel.Heading>{t('EmergencyContact1')}</Panel.Heading>
						<Panel.Body>
							<Field name='nameEmergencyContact1' component={Input} horizontal type='text' label={t('NameEmergencyContact1')} required disabled={isReadOnly} {...colSize} />
							<Field name='phoneEmergencyContact1' component={Input} horizontal type='text' label={t('PhoneEmergencyContact1')} required disabled={isReadOnly} {...colSize} />
							<Field name='relationshipEmergencyContact1' component={Input} horizontal type='text' label={t('RelationShipEmergencyContact1')} required disabled={isReadOnly} {...colSize} />
						</Panel.Body>
					</Panel>
					<Panel className='medical-information-sub-panel'>
						<Panel.Heading>{t('EmergencyContact2')}</Panel.Heading>
						<Panel.Body>
							<Field name='nameEmergencyContact2' component={Input} horizontal type='text' label={t('NameEmergencyContact2')} required disabled={isReadOnly} {...colSize} />
							<Field name='phoneEmergencyContact2' component={Input} horizontal type='text' label={t('PhoneEmergencyContact2')} required disabled={isReadOnly} {...colSize} />
							<Field name='relationshipEmergencyContact2' component={Input} horizontal type='text' label={t('RelationShipEmergencyContact2')} required disabled={isReadOnly} {...colSize} />
						</Panel.Body>
					</Panel>
					<Field name='doesHaveAllergiesOrSensitivities' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('DoesHaveAllergiesOrSensitivities')} required disabled={isReadOnly} {...colSize} />
					<Field name='allergiesOrSensitivities' component={Input} horizontal type='text' label={t('AllergiesOrSensitivities')} disabled={isReadOnly} {...colSize} />
					<Field name='hasDiagnosedAtRiskOfAnaphylaxsis' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('HasDiagnosedAtRiskOfAnaphylaxsis')} required disabled={isReadOnly} {...colSize} />
					<Field name='doesHaveAutoInjectionDevice' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('DoesHaveAutoInjectionDevice')} required disabled={isReadOnly} {...colSize} />
					<Field name='doesHaveOtherMedicalConditions' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('DoesHaveOtherMedicalConditions')} required disabled={isReadOnly} {...colSize} />
					<Field name='otherMedicalConditions' component={Input} horizontal type='text' label={t('OtherMedicalConditions')} disabled={isReadOnly} {...colSize} />
					<Field name='doesHaveOtherInformation' component={Radio} entries={yesNoOptions(t)} parse={parseBoolean} inline horizontal label={t('DoesHaveOtherInformation')} required disabled={isReadOnly} {...colSize} />
					<Field name='otherInformation' component={Input} horizontal type='text' label={t('OtherInformation')} disabled={isReadOnly} {...colSize} />
				</Panel.Body>
			</Panel>
		</div>;
	}
};

export default withResourcesNamespace(props => props.resourcesNamespace)(MedicalInformationForm);

export const RequiredFields = [
	'nameEmergencyContact1',
	'phoneEmergencyContact1',
	'relationshipEmergencyContact1',
	'nameEmergencyContact2',
	'phoneEmergencyContact2',
	'relationshipEmergencyContact2',
	'doesHaveAllergiesOrSensitivities',
	'hasDiagnosedAtRiskOfAnaphylaxsis',
	'doesHaveAutoInjectionDevice',
	'doesHaveOtherMedicalConditions',
	'doesHaveOtherInformation'
];

export const ValidationFunc = (values, t) => {
	let errors = {};

	if (values.doesHaveAllergiesOrSensitivities && !values.allergiesOrSensitivities) {
		errors['allergiesOrSensitivities'] = t('Validator_Required');
	}
	if (!values.doesHaveAllergiesOrSensitivities && values.allergiesOrSensitivities) {
		errors['allergiesOrSensitivities'] = t('Validator_NotAllowed');
	}
	if (values.doesHaveOtherMedicalConditions && !values.otherMedicalConditions) {
		errors['otherMedicalConditions'] = t('Validator_Required');
	}
	if (!values.doesHaveOtherMedicalConditions && values.otherMedicalConditions) {
		errors['otherMedicalConditions'] = t('Validator_NotAllowed');
	}
	if (values.doesHaveOtherInformation && !values.otherInformation) {
		errors['otherInformation'] = t('Validator_Required');
	}
	if (!values.doesHaveOtherInformation && values.otherInformation) {
		errors['otherInformation'] = t('Validator_NotAllowed');
	}
	return errors;
};